import React, { MouseEvent } from "react";

import { Bounds2D } from "../LineChartUtils";

interface InteractiveAreaProps {
  bounds: Bounds2D;
  onMouseDown(event: MouseEvent<SVGRectElement>): void;
  onMouseLeave(): void;
  onMouseMove(event: MouseEvent<SVGRectElement>): void;
  onMouseUp(event: MouseEvent<SVGRectElement>): void;
}

export default function InteractiveArea(props: InteractiveAreaProps): React.JSX.Element {
  return (
    <g 
      name="interactive-area"
      transform={`translate(${props.bounds.x}, ${props.bounds.y})`}
    >
      <rect
        fill="none"
        height={props.bounds.height}
        pointerEvents="all"
        onMouseDown={(event) => props.onMouseDown(event) }
        onMouseLeave={() => props.onMouseLeave() }
        onMouseMove={(event) => props.onMouseMove(event) }
        onMouseUp={(event) => props.onMouseUp(event) }
        width={props.bounds.width}
      />
    </g>
  )
}